import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-transform":"capitalize"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.operator.origin), 1),
    _createVNode(_component_router_link, {
      to: _ctx.operatorLink(_ctx.operator)
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.operator.name), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}